<template>
    <span
        class="px-2 py-1 font-semibold leading-tight  rounded-full dark:bg-green-700 dark:text-green-100"
        :class="colorClasses"
    >
      <slot/>
    </span>
</template>

<script>
export default {
    name: "Pill",
    props: {
        type: {
            type: String,
            required: true,
        }
    },
    computed: {
        colorClasses() {
            switch (this.type) {
                case 'success':
                    return 'text-green-700 bg-green-100 dark:bg-green-700 dark:text-green-100';
                case 'warning':
                    return 'text-orange-700 bg-orange-100 dark:text-white dark:bg-orange-600';
                case 'danger':
                    return 'text-gray-700 bg-red-100 dark:text-gray-100 dark:bg-red-700';
                default:
                    return 'text-gray-700 bg-gray-100 dark:text-gray-100 dark:bg-gray-700';
            }
        },
    },
}
</script>

<style scoped>

</style>
